import { GetCallResultsRequest } from '@weave/schema-gen-ts/dist/schemas/phone-exp/phone-records/v1/phone_records_api.pb';
import { PhoneCallsApi } from '@frontend/api-phone-calls';
import { AnalyticsUtils } from '@frontend/analytics-shared';
import { useAppScopeStore, useScopedQuery } from '@frontend/scope';

export const useLast30DaysMissedCallCount = ({
  locationIds,
  enabled = true,
}: {
  locationIds?: string[];
  enabled?: boolean;
}) => {
  const dateRange = AnalyticsUtils.defaultDateRangeMap['last-30-days'];
  const { selectedLocationIds } = useAppScopeStore();
  const filteredLocationIds = locationIds || selectedLocationIds || [];

  const filters: GetCallResultsRequest = {
    startTime: AnalyticsUtils.formatStartDateWithTimeZone(dateRange.startDate) ?? '',
    endTime: AnalyticsUtils.formatEndDateWithTimeZone(dateRange.endDate) ?? '',
    locationIds: filteredLocationIds,
  };

  const { data: missedCallCount, isLoading: isLoadingMissedCallCount } = useScopedQuery({
    queryKey: ['phoneAnalytics', 'callResults', filters],
    queryFn: () => PhoneCallsApi.getCallResults(filters),
    enabled: enabled && filteredLocationIds.length > 0,
    retry: false,
    select: (data) => Number(data?.missedCalls ?? 0),
  });

  return {
    missedCallCount,
    isLoadingMissedCallCount,
  };
};
